var _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReaction3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1469",
    "data-name": "Group 1469",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.916,
    height: 22.916,
    viewBox: "0 0 22.916 22.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 11.458,
    cy: 11.458,
    r: 11.458,
    transform: "translate(0 0)",
    fill: "#ffc905"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1467",
    "data-name": "Group 1467",
    transform: "translate(6.386 7.272)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 1.085,
    cy: 1.927,
    rx: 1.085,
    ry: 1.927,
    transform: "translate(7.973)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 1.085,
    cy: 1.927,
    rx: 1.085,
    ry: 1.927,
    fill: "#242424"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1468",
    "data-name": "Group 1468",
    transform: "translate(6.531 15.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2400",
    "data-name": "Path 2400",
    d: "M1746.28,510.771h-7.973a.886.886,0,1,1,0-1.771h7.973a.886.886,0,1,1,0,1.771Z",
    transform: "translate(-1737.411 -509)",
    fill: "#242424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaction3);
export default __webpack_public_path__ + "static/media/reaction3.043dfa0d616bac9afbbd3ef73dc8188c.svg";
export { ForwardRef as ReactComponent };